import React, {useEffect, useState} from 'react'
import {Modal} from "react-bootstrap";
import {SosMap} from "./SosMap";
import {Link} from "react-router-dom";
import {ISosItem} from "../../../../types/sos";
import moment from "moment";
import {LatLngTuple} from "leaflet";
import {MyTooltip} from "../../../../components/common/tooltip/Tooltip";
import {PLACEHOLDER_IMAGE_URL} from "../../../../mock/constants";
import imgBaseUrl from "../../../../utils/imgBaseUrl";

type SosMapModalProps = {
  isOpenSosModal: boolean;
  setIsOpenSosModal: (isOpen: boolean) => void;
  selectedSos: ISosItem | undefined;
}

export const SosMapModal = ({isOpenSosModal, setIsOpenSosModal, selectedSos}: SosMapModalProps) => {
  const [sosLongLat, setSosLongLat] = useState<LatLngTuple>([0, 0]);

  useEffect(() => {
    if (selectedSos) {
      setSosLongLat([selectedSos.longitude!, selectedSos.latitude!]);
    }
  }, [selectedSos]);

  return (
      <Modal centered size={"xl"} show={isOpenSosModal}
             onHide={() => setIsOpenSosModal(false)}>
        <Modal.Body className={"p-5"}>
          <div className={"row g-5"}>
            <div className={"col-md-9"}>
              <SosMap initialCenter={[sosLongLat[1], sosLongLat[0]]}/>
            </div>
            <div className={"col-md-3 d-flex flex-column"}>
              <img className={"w-100 mw-300px rounded-4"} src={imgBaseUrl(selectedSos?.user?.avatar!) || PLACEHOLDER_IMAGE_URL}
                   alt={"User"}/>
              <div className={"d-flex flex-column flex-grow-1 p-3 pb-0"}>
                <div className={"d-flex flex-column gap-4 flex-grow-1"}>
                  <div className={"d-flex justify-content-between"}>
                    <span className={"fw-bold"}>Foydalanuvchi:</span>
                    <span>{selectedSos?.user?.first_name} {selectedSos?.user?.last_name}</span>
                  </div>
                  <div className={"d-flex justify-content-between"}>
                    <span className={"fw-bold"}>Vaqt:</span>
                    <span>{moment(selectedSos?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</span>
                  </div>
                  <div className={"d-flex justify-content-between"}>
                    <span className={"fw-bold"}>Holat:</span>
                    {
                      selectedSos?.status === "DANGER" ?
                          <span className={"badge badge-light-danger fs-8 fw-bold"}>
                                 Xavfli hududda
                          </span> : <span className={"badge badge-light-primary fs-8 fw-bold"}>
                               Xavfsiz zonadaman
                          </span>
                    }

                  </div>
                  <div className={"d-flex justify-content-between"}>
                    <span className={"fw-bold"}>Manzil:</span>
                    <MyTooltip title={"Yandexda ochish"} position={"top"}>
                      <a rel={"noreferrer"} target={"_blank"}
                         href={`https://yandex.com/maps/?ll=${sosLongLat[1]},${sosLongLat[0]}&z=20&pt=${sosLongLat[1]},${sosLongLat[0]}`}
                         className={"text-end"}>{sosLongLat[0]} {sosLongLat[1]}</a>
                    </MyTooltip>
                  </div>
                </div>
                <Link to={`/sos/${selectedSos?.user?.id}`} className={"mt-auto"}>
                  <button className={"btn btn-light-primary w-100"}>Kuzatish
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className={"btn btn-secondary"} onClick={() => setIsOpenSosModal(false)}>Yopish</button>
        </Modal.Footer>
      </Modal>
  )
}
